import { JobsDashboardApi } from "./jobs-dashboard-api";
import { JobsDashboardForm } from "./jobs-dashboard-form";
import { JobsDashboardHandler } from "./jobs-dashboard-handler";
import { JobsDashboardListener } from "./jobs-dashboard-listener";
import { JobsDashboardRender } from "./jobs-dashboard-render";

export class JobsDashboardSetup {
    private readonly form: JobsDashboardForm;

    private readonly api: JobsDashboardApi;

    private readonly render: JobsDashboardRender;

    private readonly handler: JobsDashboardHandler;

    private readonly listener: JobsDashboardListener;

    public constructor(root: HTMLElement) {
        this.form = new JobsDashboardForm(root);
        this.api = new JobsDashboardApi();
        this.render = new JobsDashboardRender(this.form);
        this.handler = new JobsDashboardHandler(this.form, this.api, this.render);
        this.listener = new JobsDashboardListener(this.form, this.handler);
    }

    public async init(): Promise<void> {
        if (this.form.isInitialized()) {
            return;
        }

        this.listener.register();
        await this.handler.bootstrap();
        this.form.markInitialized();
    }

    public static async init(scope: Document | HTMLElement | ParentNode = document): Promise<void> {
        for (const target of JobsDashboardForm.getRoots(scope)) {
            const setup = new JobsDashboardSetup(target);
            await setup.init();
        }
    }
}
